/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { Layout } from './_metronic/layout';
import BasePage from './BasePage';
import { Logout, AuthPage } from './pages/Auth';

import BaseModal from './common/components/Modal';
import useCounterModal from './hooks/useCounterModal';
import { useValidateToken } from './hooks/useValidateToken';
import useRenewToken from './hooks/useRenewToken';
import { renewToken } from './api/modules/auth';
import store from './redux/store';

export function Routes() {
	const params = new URLSearchParams(window.location.search);
	const type = params.get('type');
	const filial = localStorage.getItem('type');
	const fecha =
		localStorage.getItem('vencimientoToken') ||
		store.getState()?.auth?.user?.fechaVencimientoToken;
	const { isAuthorized } = useSelector(
		({ auth }) => ({
			isAuthorized: auth?.user != null,
		}),
		shallowEqual
	);
	const { renew, setRenew } = useRenewToken(
		fecha?.slice(0, -1) || '',
		300,
		isAuthorized
	);

	if (
		window.location.pathname.search('/consultar-sesiones/sesion/') > -1 &&
		!isAuthorized
	) {
		const redirectPath = window.location.pathname.replace('/saoc-module-web', '');
		localStorage.setItem('redirectSession', redirectPath);
	}

	const onValidateToken = async () => {
		try {
			const token = store.getState()?.auth?.user?.accessToken;
			const response = await renewToken.post({ token });
			localStorage.setItem('vencimientoToken', response.fechaVencimientoToken);
			setRenew(false);
		} catch (error) {
			/* 		notice(error, 'error'); */
			console.log(error);
		}
	};

	const { isExpired, openModal, leftSeconds } = useCounterModal(5, isAuthorized);
	useValidateToken(isAuthorized);

	useEffect(() => {
		if (isExpired && fecha) {
			if (filial) {
				localStorage.setItem('login', false);
				localStorage.clear();

				window.location.href = '/saoc-module-web/auth/login?type=filial';
			} else {
				localStorage.setItem('login', false);
				window.location.href = '/saoc-module-web/logout';
				localStorage.clear();
			}
		}
	}, [isExpired]);

	useEffect(() => {
		if (renew) {
			onValidateToken();
		}
	}, [isAuthorized, renew]);

	const redirectValue = `/auth/login${type ? '?type=filial' : ''}`;

	return (
		<>
			<BaseModal
				open={openModal}
				title="Sesión a punto de expirar"
				onClose={() => {}}
			>
				<div style={{ padding: '20px', textAlign: 'center' }}>
					<p>
						Hemos detectado que no has realizado ninguna actividad por un
						tiempo.
					</p>
					<p>Tu sesión se cerrará en:</p>
					<h3
						style={{
							fontSize: '2rem',
							color: '#ff5733',
							margin: '20px 0',
						}}
					>
						{leftSeconds}
					</h3>
					<p>Por favor, realiza alguna acción para continuar con tu sesión.</p>
				</div>
			</BaseModal>

			<Switch>
				{!isAuthorized ? (
					<>
						<Redirect to={redirectValue} />
						<Route>
							<AuthPage />
						</Route>
					</>
				) : (
					<Redirect from="/auth" to="/" />
				)}
				<Route path="/logout" component={Logout} />

				{!isAuthorized ? (
					<Redirect to={redirectValue} />
				) : (
					<Layout>
						<BasePage />
					</Layout>
				)}
			</Switch>
		</>
	);
}
